/**
 * A directive component that renders the given src url as an html partial
 * and compiles it in the same scope as its parent.
 * @param {any} $compile The angular compile service
 * @param {any} $templateRequest The template request service.
 * @returns {any} The directive.
 */
export function PartialSrcDirective($compile, $templateRequest) {
    'ngInject'
    return {
        restrict: "A",
        link: function (scope, el, attrs) {
            const srcUrl = attrs.apexPartialSrc;
            $templateRequest(srcUrl)
                .then(function (template) {
                    el.html(template);
                    $compile(el.contents())(scope);
                });
        }
    };
}
